<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Sales Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>Invoice No. </label>
                <input type="text" class="form-control" v-model="salesdetail.invoiceNo" disabled id="name" aria-describedby="action">
            </div>
            <div class="form-group col-3">
                <label for="module">Invoice Date</label>
                <flat-pickr class="form-control" v-model="salesdetail.date" id="date"></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Customer</label>
                <app-lookup-field :model="salesdetail" :element="customerLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-2">
                <label>PPN</label>
                <div class="input-group-text col-lg-6">
                    <!-- <input type="checkbox" aria-label="Checkbox for following text input" v-model="salesdetail.isPpn" @click="calcPpn"> -->
                    <input type="checkbox" v-model="salesdetail.isPpn" id="btk-purchase-is-ppn">
                </div>
                <!-- <input type="checkbox" class="form-control" v-model="salesdetail.isPpn" @click="calcPpn" id="isPpn"> -->
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label>Remark</label>
                <textarea class="form-control" id="desc-textarea" v-model="salesdetail.remark" rows="3"></textarea>
            </div>
        </div>
        <br /><br />
        Product Detail
        <br />
        <app-datatable :type="'input'" :newData="newSalesDetail" :elements="dtElementsSalesDetail" :collections="salesdetail.salesDetail"></app-datatable>
        <total-price :total="getTotal" :ppn="getPpn" :grandTotal="getGrandTotal"></total-price>
        <br /><br />
       
        
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import moment from 'moment'
import { sales, salesDetail } from '../../models/sales'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import TotalPrice from '../../components/TotalPrice.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar, TotalPrice
    },
    data() {
        return {
            salesdetail: {...sales, salesDetail: []},
            newSalesDetail: salesDetail,
            customerLookup: {
                id: 'customer',
                title: 'Customer',
                type: 'form',
                apiUrl: 'customer-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Customer',
                        width: 12,
                        column: 'customerName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'customerId'
                    },
                    {
                        from: 'name',
                        to: 'customerName'
                    },
                ]
            },
            dtElementsSalesDetail: [
              {
                title: 'Product Name',
                column: 'productName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'salesProduct',
                    title: 'Product Data',
                    type: 'table',
                    apiUrl: 'product-with-stock-list',
                    filter: ['productName'],
                    fields: [
                        {
                            placeholder: 'Product Name',
                            width: 5,
                            column: 'productName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'Product Name',
                            column: 'productName'
                        },
                        {
                            title: 'Warehouse Name',
                            column: 'warehouseName'
                        },
                        {
                            title: 'Qty On Hand',
                            column: 'qty'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'productId',
                            to: 'productId'
                        },
                        {
                            from: 'productName',
                            to: 'productName'
                        },
                        {
                            from: 'warehouseId',
                            to: 'warehouseId'
                        },
                        {
                            from: 'warehouseName',
                            to: 'warehouseName'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Warehouse',
                column: 'warehouseName',
                type: 'text',
                width: 6,
                disable: true
              },
            //   {
            //     title: 'Warehouse',
            //     column: 'warehouseName',
            //     type: 'lookup',
            //     width: 6,
            //     lookup: {
            //         id: 'salesWarehouse',
            //         title: 'Warehouse',
            //         type: 'table',
            //         apiUrl: 'warehouse-list',
            //         filter: ['name'],
            //         fields: [
            //             {
            //                 placeholder: 'Warehouse',
            //                 width: 5,
            //                 column: 'warehouseName'
            //             }
            //         ],
            //         dtElements: [
            //             {
            //                 title: 'Warehouse',
            //                 column: 'name'
            //             },
            //         ],
            //         affectedField: [
            //             {
            //                 from: 'id',
            //                 to: 'warehouseId'
            //             },
            //             {
            //                 from: 'name',
            //                 to: 'warehouseName'
            //             },
            //         ]
            //     },
            //     disable: true,
            //   },
                {
                    title: 'Qty',
                    column: 'qty',
                    type: 'number',
                    width: 6,
                },
                {
                    title: 'Price',
                    column: 'price',
                    type: 'number',
                    width: 6,
                },
            ],
        }
    },
    // watch: {
    //     'salesdetail': {
    //         handler: function() {
    //             // watch deeply for every changes on rsdetail to calculate sample cost
    //             // for(let i=0; i<this.rs.requestSampleDetail.length;i++) {
    //             //     const uomId = this.rs.requestSampleDetail[i].UOM
    //             //     const uom = listUom.find(x => x.value === uomId)
    //             //     this.rs.requestSampleDetail[i].sampleCost = this.rs.requestSampleDetail[i].qty * this.rs.requestSampleDetail[i].sampleCostMT * (uom ? uom.conversion : 0)
    //             // }
    //             var tempTotal = 0
    //             for(let i=0; i<this.salesdetail.salesDetail.length;i++) {
    //                 tempTotal += this.salesdetail.salesDetail[i].qty * this.salesdetail.salesDetail[i].price
    //             }
    //             this.salesdetail.total = tempTotal
                
    //             this.salesdetail.grandTotal = this.salesdetail.isPpn ? (this.salesdetail.total + (this.salesdetail.total * 0.1)) : this.salesdetail.total
    //         },
    //         deep: true
    //     }
    // },
    async created() {
        if(this.$route.query.id !== undefined) {
            const salesApi = api('sales/detail')

            const salesResult = await salesApi.getWithParams(this.$route.query.id)
            // console.log(salesResult);
            this.salesdetail = salesResult

            console.log(this.salesdetail.salesDetail);
        }
    },
    computed: {
        getTotal() {
            return this.salesdetail.salesDetail.reduce((prev, curr) => prev + (curr.qty * curr.price), 0);
        },
        getPpn() {
            // return this.salesdetail.isPpn ? this.getTotal * 0.1 : 0;

            // console.log(this.salesdetail.date)
            // console.log(moment(this.salesdetail.date).format('M'))
            // console.log(moment(this.salesdetail.date).format('Y'))
            const invoiceMonth = moment(this.salesdetail.date).format('M')
            const invoiceYear = moment(this.salesdetail.date).format('Y')
            let ppn = 10;
            if(invoiceYear > 2022) {
                ppn = 11;
            } else if (invoiceYear < 2022) {
                ppn = 10;
            } else if(invoiceYear == 2022) {
                if(invoiceMonth > 3) {
                    ppn = 11
                } else {
                    ppn = 10;
                }
            }
            // if (invoiceYear >= 2022 && invoiceMonth > 3) {
            //     ppn = 11;
            // } else {
            //     ppn = 10;
            // }
            return this.salesdetail.isPpn ? this.getTotal * ppn / 100 : 0;
        },
        getGrandTotal() {
            return this.getTotal + this.getPpn;
        }
    },
    methods: {
        async save() {
            const salesApi = api('sales')
            if(this.$route.query.id !== undefined) {
                await salesApi.update(this.salesdetail, this.$route.query.id)
            } else {
                await salesApi.create(this.salesdetail)
            }
            this.$router.push({ name: 'sales' })
        },
        cancel() {
            this.$router.push({ name: 'sales' })
        },
        finishLookup(data) {
            const currentSales = this.salesdetail
            this.salesdetail = {
                ...currentSales,
                ...data
            }
        },
        finishUpload(data) {
            const currentSales = this.salesdetail
            this.salesdetail = {
                ...currentSales,
                ...data
            }
        },
    }
}
</script>